<template>
    <div>
        <div v-if="pending">
            <BaseSpinner />
        </div>
        <template v-else-if="!entry" /> <!-- empty case for when there is no entry, nuxt will show an error -->
        <div v-else>
            <article class="team-page">
                <HeroBasic
                    :title="entry?.title"
                    :description="entry?.description"
                >
                    <template #backlink>
                        <NuxtLink :to="localePath(t('teamOverview.backlink.uri'))">
                            <div class="sr-only">{{ t('a11y.return-to') }}</div>
                            <BaseIcon icon="chevron-left" />
                            {{ t('teamOverview.backlink.label') }}
                        </NuxtLink>
                    </template>
                </HeroBasic>

                <TeamOverview />
            </article>
        </div>
    </div>
</template>

<script setup>
import { formatISO } from 'date-fns';
import getPage from '~/graphql/queries/getPage.graphql';

const localePath = useLocalePath();
const { t } = useI18n();

const { variables: defaultVariables }  = useCraftGraphql();

const variables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });

    return {
        ...defaultVariables,
        now: ['or', `>= ${now}`, null]
    };
});

const response = await useAsyncQuery({
    query: getPage,
    variables
});

// using response.pending in template is not reactive???
const pending = computed(() => response?.pending.value);

const { craftEntry: entry } = useCraftPageEther(response);

const mainStore = useMainStore();
watchEffect(() => {
    mainStore.toggleNewsletterSubscribe(entry.value?.showNewsletterSubscribe ?? false);
});
</script>

<style lang="less">
.team-page {
    .hero-basic__content {
        --max-width: var(--grid-maxWidth-page-extraWide);

        > div {
            max-width: var(--grid-maxWidth-page-extraWide);
        }
    }
}

@media @q-xxl-min {
    .team-page {
        .hero-basic__content {
            grid-template-columns: 1fr min(var(--max-width), 100%) 1fr;
        }
    }
}
</style>
